var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.2734V11.6068H5.83333V18.2734M5.83333 3.27344V7.4401H12.5M15.8333 18.2734H4.16667C3.72464 18.2734 3.30072 18.0978 2.98816 17.7853C2.67559 17.4727 2.5 17.0488 2.5 16.6068V4.9401C2.5 4.49808 2.67559 4.07415 2.98816 3.76159C3.30072 3.44903 3.72464 3.27344 4.16667 3.27344H13.3333L17.5 7.4401V16.6068C17.5 17.0488 17.3244 17.4727 17.0118 17.7853C16.6993 18.0978 16.2754 18.2734 15.8333 18.2734Z",
    stroke: "#3538CD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.ddb137af5d5f800f859cb7940f75b76f.svg";
export { ForwardRef as ReactComponent };